import { JOURNEY_STEPS } from "@/lib/constants";

interface Props { active: number }

export function ProgressRail({ active }: Props) {
  return (
    <div className="progress-rail" aria-label={`三问进度 ${Math.max(0, active)} / 3`}>
      {JOURNEY_STEPS.map((step, index) => (
        <div className={`progress-step ${index < active ? "is-done" : ""} ${index === active ? "is-current" : ""}`} key={step.label}>
          <span className="progress-dot">{index < active ? "✓" : step.short}</span>
          <span>{step.label}</span>
        </div>
      ))}
    </div>
  );
}
